<template>

</template>

<script>
  export default {
    data: () => ({
      now: undefined,
      timer: undefined
    }),

    computed: {
      activeRetend() {
        const now = this.now;
        return _.find(this.lot.retends, e => e.startTime <= now && e.endTime >= now && e.state.REGISTERED);
      },

      retendTimeLeft() {
        const retend = this.activeRetend;
        let timeLeft;

        if (retend) {
          timeLeft = Math.trunc((retend.endTime.getTime() - this.now) / 1000);
        }

        return timeLeft >= 0 ? timeLeft : undefined;
      },

      nextRetendRequestTimeLeft() {
        const retend = this.activeRetend;

        let timeLeft;

        if (retend) {
          timeLeft = Math.trunc((retend.calculatedEndTime.getTime() - this.now) / 1000);
        }

        return timeLeft >= 0 ? timeLeft : undefined;
      }
    },

    created() {
      this.now = Date.now() + this.lot.serverDeltaTime;

      this.timer = setInterval(() => {
        if (this.lot && (this.lot.state.RETEND || this.lot.state.WAITING_FOR_RETEND)) {
          this.now = Date.now() + this.lot.serverDeltaTime;
        }
      }, 1000);
    },

    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
  }
</script>

<style scoped>

</style>
